<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-75">
        <md-card>
          <md-card-header data-background-color="purple">
            <div class="md-layout md-alignment-center-space-between">
              <h4 class="title">Hardware OTPs</h4>
              <div style="display: flex">
                <md-button
                  v-if="!isViewerAdmin"
                  @click="otpImporterVisible = true"
                  class="md-icon-button md-dense refresh-btn"
                >
                  <md-tooltip md-direction="top">Import CSV</md-tooltip>
                  <md-icon>add</md-icon>
                </md-button>
                <search-box v-model="search" @doSearch="doSearch"></search-box>
                <md-button class="md-icon-button md-dense refresh-btn" @click="refreshList">
                  <md-tooltip md-direction="top">Refresh</md-tooltip>
                  <md-icon>refresh</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-header>
          <md-card-content>
            <div>
              <md-table v-model="hardwareOtps" table-header-color="purple" md-card>
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Serial Number">{{ item.serial_number }}</md-table-cell>
                  <md-table-cell md-label="Step">{{ item.step }}</md-table-cell>
                  <md-table-cell md-label="Tolerance">{{ item.tolerance }}</md-table-cell>
                  <md-table-cell md-label="Asigned to">{{ item.assigned_to }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            <div class="md-layout md-alignment-center">
              <pagination v-model="usersPage" :page-count="totalPages" @input="changePage"></pagination>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
        <md-card>
          <md-card-header data-background-color="orange" class="md-layout">
            <h4 class="title filter-by">Filter By</h4>
          </md-card-header>
          <md-card-content class="filters">
            <md-list>
              <div v-if="searched">
                <md-subheader class="filter-radio">
                  Search
                  <md-button class="md-icon-button md-dense" @click="removeSearch" v-if="searched">
                    <md-icon>clear</md-icon>
                  </md-button>
                </md-subheader>
                <md-radio v-model="searched" :value="searched">{{ searched }} </md-radio>
              </div>
              <md-divider v-if="searched"></md-divider>
              <md-subheader class="filter-radio">
                State
                <md-button class="md-icon-button md-dense" @click="removeFilters" v-if="filterState !== 'ALL'">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-subheader>
              <md-radio v-model="filterState" value="ALL">All</md-radio>
              <md-radio v-model="filterState" value="AS"> Assigned</md-radio>
              <md-radio v-model="filterState" value="NAS">Not Assigned</md-radio>
            </md-list>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <import-otp-with-csv
      :show="otpImporterVisible"
      @close="otpImporterVisible = false"
      @refreshTable="fetchHardwareOtps(false)"
    ></import-otp-with-csv>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import { Pagination } from "@/components";
import SearchBox from "../../components/SearchBox";
import apiManager from "@/api-manager";
import ImportOtpWithCsv from "./ImportOtpWithCsv.vue";

export default {
  name: "HardwareOtpsList",
  components: {
    SearchBox,
    Pagination,
    ImportOtpWithCsv,
  },
  setup(props, context) {
    const isViewerAdmin = computed(() => {
      return window.localStorage.getItem("adminGroups").includes("viewer_admins");
    });

    const hardwareOtps = ref([]);
    const totalPages = ref(1);
    const currentPage = ref(1);
    const filterState = ref("ALL");
    const search = ref("");
    const searched = ref("");
    const fetchHardwareOtps = async (is_assigned) => {
      const response = await apiManager.getHardwareDevicesList({
        params: {
          is_assigned: is_assigned,
          page: currentPage.value,
          serial_number__icontains: searched.value,
        },
      });
      hardwareOtps.value = response.parsedData.hardwares;
      totalPages.value = response.parsedData.total_pages;
    };

    const removeFilters = () => {
      filterState.value = "ALL";
    };

    const removeSearch = () => {
      searched.value = "";
      search.value = "";
      fetchHardwareOtps(false);
    };

    const doSearch = () => {
      searched.value = search.value;
      fetchHardwareOtps(false);
    };

    watch(filterState, () => {
      if (filterState.value === "AS") {
        fetchHardwareOtps(true);
      } else if (filterState.value === "NAS") {
        fetchHardwareOtps();
      } else if (filterState.value === "ALL") {
        fetchHardwareOtps(false);
      }
    });

    const changePage = (page) => {
      currentPage.value = page;
      fetchHardwareOtps();
    };

    const refreshList = () => {
      filterState.value = "ALL";
      fetchHardwareOtps(false);
    };

    onMounted(() => {
      fetchHardwareOtps(false);
    });

    const otpImporterVisible = ref(false);

    return {
      isViewerAdmin,
      hardwareOtps,
      filterState,
      totalPages,
      search,
      searched,
      doSearch,
      removeFilters,
      changePage,
      fetchHardwareOtps,
      removeSearch,
      otpImporterVisible,
      refreshList,
    };
  },
};
</script>

<style lang="scss" scoped>
.is-active {
  .md-icon {
    margin-left: 16px;
    margin-right: 16px;
  }
}
</style>
